import { createTheme } from "@mui/material";
import { Components, Theme } from "@mui/material/styles";

const baseTheme = createTheme();

const MuiAlert: Components<Theme>["MuiAlert"] = {
  styleOverrides: {
    standard: {
      color: baseTheme.palette.text.primary,
      backgroundColor: baseTheme.palette.background.paper,
    },
  },
};

export default MuiAlert;
